module.exports = __webpack_public_path__ + "img/about-2.6d3553a4.jpg";